// extracted by css-extract-rspack-plugin
export default {"inlineLink":"inlineLink-adAOOa","groupCard":"groupCard-U7Uxej"};